import React from "react";
import { Store, CombinedState } from "redux";
import {
    RouterState,
    LocationChangeAction,
    ConnectedRouter,
} from "connected-react-router";
import { Provider } from "react-redux";
import { History } from "history";
import Router from "Router";

interface Props {
    history: History;
    store: Store<
        CombinedState<{
            router: RouterState<any>;
        }>,
        LocationChangeAction<any>
    > & {
        // eslint-disable-next-line @typescript-eslint/ban-types
        dispatch: {};
    };
}

const App: React.FC<Props> = ({ history, store }) => {
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Router />
            </ConnectedRouter>
        </Provider>
    );
};

export default App;
